<script lang="ts">
  import { router } from '@inertiajs/svelte';

  interface Survey {
    id?: string;
    slug: string;
    title: string;
    description: string | null;
    questions: unknown[];
    tier_rules: Record<string, { min_score: number; max_score: number }>;
    published_at?: string | null;
  }

  let { survey }: { survey: Survey } = $props();

  let slug = $state(survey.slug);
  let title = $state(survey.title);
  let description = $state(survey.description ?? '');
  let questionsJson = $state(JSON.stringify(survey.questions, null, 2));
  let tierRulesJson = $state(JSON.stringify(survey.tier_rules, null, 2));
  let publishedAt = $state(survey.published_at ?? '');

  function save() {
    let questions: unknown[], tierRules: unknown;
    try {
      questions = JSON.parse(questionsJson);
      tierRules = JSON.parse(tierRulesJson);
    } catch (e) {
      alert('JSON 파싱 실패: ' + e);
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const payload: any = {
      survey: {
        slug,
        title,
        description,
        questions,
        tier_rules: tierRules,
        published_at: publishedAt || null
      }
    };

    if (survey.id) {
      router.patch(`/admin/community/surveys/${survey.slug}`, payload);
    } else {
      router.post('/admin/community/surveys', payload);
    }
  }
</script>

<div class="p-6 max-w-4xl space-y-4">
    <div class="flex items-center gap-4">
      <a href="/admin/community/surveys" class="text-sm text-gray-600 hover:underline">← 설문 목록</a>
      <h1 class="text-2xl font-bold">{survey.id ? '설문 편집' : '새 설문'}</h1>
    </div>

    <label class="block">
      <span class="text-sm font-medium">Slug (kebab-case)</span>
      <input bind:value={slug} class="w-full border rounded px-3 py-2 mt-1"
             placeholder="my-survey-2026" />
    </label>

    <label class="block">
      <span class="text-sm font-medium">제목</span>
      <input bind:value={title} class="w-full border rounded px-3 py-2 mt-1"
             placeholder="설문 제목" />
    </label>

    <label class="block">
      <span class="text-sm font-medium">설명</span>
      <textarea bind:value={description} class="w-full border rounded px-3 py-2 mt-1" rows="3"
                placeholder="설문 설명 (선택사항)"></textarea>
    </label>

    <label class="block">
      <span class="text-sm font-medium">공개 시각 (비우면 초안)</span>
      <input type="datetime-local" bind:value={publishedAt} class="border rounded px-3 py-2 mt-1" />
    </label>

    <label class="block">
      <span class="text-sm font-medium">Questions (JSON)</span>
      <textarea bind:value={questionsJson}
                class="w-full border rounded px-3 py-2 mt-1 font-mono text-xs"
                rows="15"></textarea>
    </label>

    <label class="block">
      <span class="text-sm font-medium">Tier Rules (JSON)</span>
      <textarea bind:value={tierRulesJson}
                class="w-full border rounded px-3 py-2 mt-1 font-mono text-xs"
                rows="6"></textarea>
    </label>

    <div class="flex gap-2">
      <button onclick={save} class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
        저장
      </button>
      <a href="/admin/community/surveys" class="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">
        취소
      </a>
    </div>
  </div>
